import {
  IBillingManagement,
  IBillingManagementDetail,
} from "../../types/billing-management.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const makeRequestDebounced = createDebounce(makeRequest, 200);
const API_URL = `${import.meta.env.VITE_API_URL}/billing-management`;

export async function getBillingManagement({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 100,
  orderBy = "",
  splitDone = undefined,
  startDate = "",
  endDate = "",
  plateSource = "",
  reason = "",
  fields = "paymentId,customerId,vehicleId,paymentVehicleId,status,invoiceNumber,licensePlate,expectedLicensePlate,paymentVehicleLicensePlate,descriptionLicensePlate,plateSource,splitWalletId,splitPercent,splitStatus,splitDone,partnerId,partnerCompany,partnerWalletId,splitPartnerCompany,description,reason,createdAt",
}: {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
  splitDone?: boolean;
  startDate?: string | Date | null;
  endDate?: string | Date | null;
  plateSource?: string;
  reason?: string;
  fields?: string;
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  params.append("pageOptions[page]", String(page));
  params.append("pageOptions[itemsPerPage]", String(itemsPerPage));

  if (splitDone !== undefined) {
    params.append("filters[splitDone]", splitDone.toString());
  }

  if (startDate) {
    params.append("filters[startDate]", String(startDate));
  }

  if (endDate) {
    params.append("filters[endDate]", String(endDate));
  }

  if (plateSource) {
    params.append("filters[plateSource]", plateSource);
  }

  if (reason) {
    params.append("filters[reason]", reason);
  }

  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IBillingManagement[]
  > & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getBillingManagementDetails(paymentId: string) {
  const url = `${API_URL}/${paymentId}/details`;
  return (await makeRequestDebounced(url)) as ApiResponseType<IBillingManagementDetail>;
}
